import { OperatingUnit } from './operating-unit.model';
import { ProjectClass } from './project-class.model';

export class Allocation {
  projectID: string;
  operatingUnit: OperatingUnit;
  fundingProjectID: any;
  projectClass: ProjectClass;
  percentage: number;
  businessUnit: string;
  businessUnitValue: string;
  state: string;
  projectType: string;
  fundingProjectOptions: any[];
  stateOptions: any[];
  projectClassOptions: any[];
  projectTypeOptions: any[];
  displayOperatingUnit: string;
  setId: string;
  function: string;
  hasFundingError: boolean;

  constructor() {
    this.percentage = null;
    this.fundingProjectOptions = [];
    this.stateOptions = [];
    this.projectClassOptions = [];
    this.projectTypeOptions = [];
    this.hasFundingError = false;
  }
}
